import { Checkbox } from '@digdir/designsystemet-react';
import { useFormContext } from 'react-hook-form';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { CardContentWrapper } from '../../../../solceller/form/components/styledComponents';
import { TermostatstyringRadio } from '../common/termostatstyringRadio';
import { StyledCard } from '../../../../../../../components/registering/steps/base/form/detailingSelect/components/styledComponents';
import { OppvarmingFormData } from '../../../types';
import { InstallasjonsArRadio } from '../../../../../components/installasjonsArRadio';

import { useBioenergiValidation } from './useBioenergiValidation';

export const BiokaminCheckbox = () => {
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming' });
  const { validateBioenergiSelection } = useBioenergiValidation();

  const biokaminSelected = watch('bioenergi.value.kamin.selected');
  const kaminError = formState.errors?.bioenergi?.value?.kamin?.selected;

  return (
    <StyledCard isActive={biokaminSelected}>
      <CardContentWrapper>
        <Checkbox
          aria-invalid={!!kaminError}
          label={t('bioenergi.biokamin.label')}
          {...register('bioenergi.value.kamin.selected', {
            validate: validateBioenergiSelection,
            deps: ['bioenergi.value.kjel.selected', 'bioenergi.value.kaminMedVannbarenVarme.selected'],
            shouldUnregister: true
          })}
        />
        {biokaminSelected && (
          <Fragment>
            <InstallasjonsArRadio
              name={`bioenergi.value.kamin.value`}
              translationKeyPrefix={`form.oppvarming.bioenergi.biokamin.installasjonsAr`}
            />
            <TermostatstyringRadio name="bioenergi.value.kamin.value.termostatstyring" />
          </Fragment>
        )}
      </CardContentWrapper>
    </StyledCard>
  );
};
